import React, { useCallback } from 'react'
import { withTransaction } from '@elastic/apm-rum-react'
import StyledPageHeader from 'components/PageHeader/StyledPageHeader'
import { useTranslation } from 'contexts/Localization'
import { Route } from 'react-router-dom'
import styled from 'styled-components'
import { Flex, useModal, Button, Link } from 'vvs-uikit'
import { useWeb3React } from '@web3-react/core'
import { usePollUserVvsBar, usePollUserVvsBoost, usePollVvsBoostPoolData } from 'state/xVvs/hooks'
import { StyledHeading } from './styles'
import BarCard from './component/BarCard'
import SubNav from './component/SubNav'
import ProductGuideModal from './component/ProductGuideModal'
import VaultCard from './component/VaultCard'

const OverridedStyledPageHeader = styled(StyledPageHeader)`
  max-height: 350px;
`
const StyledImg = styled.img`
  height: 375px;
  width: 552px;
  margin-right: 4rem;

  display: none;

  ${({ theme }) => theme.mediaQueries.xl} {
    display: block;
  }
`

function XVvs() {
  const { t } = useTranslation()
  const { account } = useWeb3React()

  // Poll user data for xVVS
  usePollUserVvsBar(account)
  usePollUserVvsBoost(account)
  usePollVvsBoostPoolData()

  const renderContent = useCallback((): JSX.Element => {
    return (
      <>
        <Route exact path="/xvvs" component={BarCard} />
        <Route exact path="/xvvs/vault" component={VaultCard} />
        <Route exact path="/xvvs/vault/earnings" component={VaultCard} />
        <Route exact path="/xvvs/vault/boost" component={VaultCard} />
      </>
    )
  }, [])

  const [onPresentLearnModeModal] = useModal(<ProductGuideModal />, true, true, 'learnModeModal')

  return (
    <>
      <OverridedStyledPageHeader>
        <Flex
          style={{ position: 'relative' }}
          justifyContent="space-between"
          flexDirection={['column', null, null, 'row']}
        >
          <Flex flexDirection="column">
            <StyledHeading as="h1" scale="xxl" mb="24px" weight={500}>
              {t('xVVS')}
            </StyledHeading>
            <StyledHeading scale="md">{t('Stake VVS for xVVS to receive a share of platform profits.')}</StyledHeading>
            <StyledHeading scale="md" mb="12px" mt="14px">
              {t('Deposit xVVS in one of our vaults to boost your earnings!')}
            </StyledHeading>
            <Button p={0} variant="text" as={Link} onClick={onPresentLearnModeModal}>
              {t('Product Guide')}
            </Button>
          </Flex>
          <Flex alignItems="center" justifyContent="center" flexDirection="column">
            <SubNav />
            {renderContent()}
          </Flex>
        </Flex>
      </OverridedStyledPageHeader>
      <Flex>
        <Flex flex="1" justifyContent="flex-end">
          <StyledImg alt="vault mole" src="/images/xVVS/vault-mole.png" />
        </Flex>
        <Flex flex="1"> </Flex>
      </Flex>
    </>
  )
}

export default withTransaction('XVvs', 'component')(XVvs)
